import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions';
import Item from './Item';
import Form from '../Form/Form';
import Popup from '../Form/Popup';
import { initJqCode, trackEvent } from '../../libs';

class Brochures extends React.Component {
  componentWillMount() {
    this.setState({ counter: 15 });
  }

  componentDidMount() {
    this.interval = setInterval(this.countDown, 1000);

    setTimeout(() => {
      trackEvent({
        hitType: 'pageview',
        page: location.pathname + location.search + location.hash,
      });
    }, 300);
  }

  countDown = () => {
    const left = this.state.counter;

    if (window.jQuery || left === 0) {
      clearInterval(this.interval);

      if (window.jQuery) {
        initJqCode();
      }
    } else {
      this.setState({
        counter: left - 1,
      });
    }
  };

  toggleItem = (name, value) => {
    this.props.actions.setBrochures({ name, value });
  };

  render() {
    const { carList, brochures } = this.props;
    const $formContainer = $('.form-container');
    const $selectedServices = $('.selected-services');
    const $someSelected = brochures.length;

    if (window.jQuery && $formContainer.length && $selectedServices.length) {
      const $top = $formContainer.offset().top;
      const $y = $(window).scrollTop() + $(window).height();

      if ($someSelected) {
        $selectedServices.removeClass('empty');
      } else {
        $selectedServices.addClass('empty');
      }

      if ($y <= $top) {
        $selectedServices.addClass('isSticky');
      } else {
        $selectedServices.removeClass('isSticky');
      }

      $(window).scroll(() => {
        const $top = $formContainer.offset().top - $(window).height();
        const $sY = $(window).scrollTop();
        const $sY2 = $(window).scrollTop() - $selectedServices.height();

        if ($someSelected && $sY <= $top) {
          $selectedServices.addClass('isSticky');
        } else if ($sY2 >= $top) {
          $selectedServices.removeClass('isSticky');
        }
      });
    }

    return (
      <div className="car-catalog">
        <div className="cmp-horizontal-hero">
          <section
            id="mainfocus"
            className="mainfocus page-header-default"
            data-bt-eventclass="componentevent"
            data-bt-category="component"
            data-bt-componentname="mainfocus"
          >
            <div
              data-background-desktop="//brochures-pages.toyota.ru/header-jpg.jpg"
              data-background-mobile="//brochures-pages.toyota.ru/header-mobile.jpg"
              className="focus-height hero-unit hero-medium fullwidth background image0"
            >
              <header className="container header-left header-dark">

              </header>
            </div>
          </section>
          <div className="container" id="horizontalhero_copy__47c8f0d4-1b2b-3baf-8037-2240b94b9139">

            <div className="hero-body col-lg-8 col-12">
              <h1 className="hero-title t-gamma-text l-gamma-text k-sub-beta-text pb-4 mb-4 position-relative" style={{textTransform: 'uppercase'}}>
                Модельный ряд
              </h1>


            </div>
          </div>
        </div>
        <div className="container car-catalog__container">
          <div className="row">
            <div className="col-xs-12 car-catalog__intro">
              <div className="car-catalog__intro__text">
                Узнайте больше о&nbsp;моделях Toyota, ознакомившись со&nbsp;справочными материалами по&nbsp;модели. Вы&nbsp;можете выбрать, каким образом изучить материалы:
              </div>
              <div className="car-catalog__intro__services">
                <div className="car-catalog__intro__button">
                  <div className="car-catalog__intro__icon __eye"/>
                  Посмотреть материалы о модели в режиме онлайн
                </div>
                <div className="car-catalog__intro__button">
                  <div className="car-catalog__intro__icon __mail"/>
                  Отправить ссылку на почту для скачивания материалов
                </div>
              </div>
            </div>
            <div className="col-xs-12 car-catalog__title">
              <strong>
                1. Выберите интересующую вас модель, а также тип материала,
                который вы хотите изучить:
              </strong>
            </div>
            {!!carList.length && carList.map(i =>
              (<div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 car-item" key={i.id}>
                <div className="car-item__img"><img src={i.image} /></div>
                <div className="car-item__title"><strong>{i.name}</strong></div>
                {i.brochures.map(brochure => (<Item
                  name={`${i.name} ${brochure.title}.pdf`}
                  carId={i.id}
                  carUrlPart={i.urlPart}
                  key={brochure.type}
                  type={brochure.type}
                  title={brochure.title}
                  value={brochure.value}
                  preview={brochure.preview}

                  onClick={this.toggleItem}
                />))}
              </div>)
            )}
          </div>
        </div>
        <div className="selected-services">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <div className="selected-services__title"><strong>Вы
                  выбрали:</strong></div>
                <div className="selected-services__container">
                  {!!brochures.length && brochures.map((i, k) => (
                    <div
                      key={k}
                      className="selected-services__item"
                    >
                      {i.name}
                      <div
                        className="selected-services__item__close"
                        onClick={() => this.toggleItem(i.name)}
                      />
                    </div>
                  ))}
                </div>
                <button
                  className="btn btn-action-primary selected-services__button">
                  Продолжить
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="container form-container">
          <div className="row">
            <div className="col-xs-12 form-header">
              <strong>
                2. Пожалуйста, заполните форму ниже, и мы отправим материалы на вашу электронную почту.
              </strong>
            </div>
          </div>
          <Form brochures={brochures} />
          <Popup />
        </div>
      </div>
    );
  }
}

Brochures.propTypes = {
  actions: PropTypes.object.isRequired,
  dispatch: PropTypes.func,
  carList: PropTypes.array,
  brochures: PropTypes.array,
};

function mapStateToProps(state) {
  return {
    carList: state.mainReducer.carList,
    brochures: state.mainReducer.brochures,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Brochures);



// WEBPACK FOOTER //
// ./src/components/Brochures/Brochures.js